import { i18n } from '@lingui/core';

export function formatDistance(distanceInKm: number): string {
    if (distanceInKm < 0.1) {
        return i18n.t({
            id: 'distance.less-than-100m',
            message: '100 meters or less',
        });
    } else if (distanceInKm < 1) {
        const roundedDistance = Math.round(distanceInKm * 100) * 10;
        return i18n.t({
            id: 'distance.in-meters',
            message: '{distance} meters',
            values: { distance: roundedDistance },
        });
    } else if (distanceInKm < 10) {
        const roundedDistance = distanceInKm.toLocaleString(i18n.locale, {
            maximumFractionDigits: 1,
        });
        return i18n.t({
            id: 'distance.in-kilometers',
            message: '{distance} km',
            values: { distance: roundedDistance },
        });
    } else {
        return i18n.t({
            id: 'distance.in-kilometers',
            message: '{distance} km',
            values: { distance: Math.round(distanceInKm) },
        });
    }
}
